import {hideLoading} from '../assets/js/functions'

export function afterEach () {
  // Remove initial loading
  hideLoading()
}
